/* eslint-disable */

import React from "react";

export enum ShnoodleImageType {
  Waterfall,
  WateringCan,
  Phone,
  Unknown,
}

export const ShnoodleImage = ({
  shnoodleType = ShnoodleImageType.WateringCan,
  isSmall = false,
}) => {
  // TODO: These are no longer images of shoodle but instead icons with coloured background.  Needs work to refactor.
  const baseUrl =
    "https://production-raindrop-s3-public.s3.eu-west-2.amazonaws.com/";

  const fileName = {
    [ShnoodleImageType.WateringCan]: "shnoodle__handrawn__wateringcan.webp",
    [ShnoodleImageType.Phone]: "shnoodle__handrawn__phone.webp",
  }[shnoodleType.toString()];

  const src = baseUrl + fileName;

  let sizeClass = "w-64";

  if (isSmall) {
    sizeClass = "w-32";
  }

  if (shnoodleType === ShnoodleImageType.Unknown) {
    return null;
  }

  if (shnoodleType === ShnoodleImageType.WateringCan) {
    return (
      <div className="flex flex-col items-center justify-center w-20 h-20 aspect-square bg-color-raindrop-primary rounded-xl">
        <i className="fa-solid fa-book-open text-5xl text-white opacity-80" />
      </div>
    );
  }

  if (shnoodleType === ShnoodleImageType.Waterfall) {
    return (
      <div className="flex flex-col items-center justify-center w-20 h-20 aspect-square bg-cyan-500 rounded-xl">
        <i className="fa-solid fa-glass-water-droplet text-5xl text-white opacity-80" />
      </div>
    );
  }

  return (
    <img
      src={src}
      className={`${sizeClass} rounded-3xl border border-white  aspect-square`}
    />
  );
};
